export default __webpack_public_path__ + "static/06-c6cba717ca53aecac13bc83d90fdff4b.jpg";